module.exports = __webpack_public_path__ + "img/credit-card-dent-red.611e0976.svg";